export function findScrollParent(
  element: HTMLElement,
  { overflowingOnly = false }: Readonly<{ overflowingOnly?: boolean }> = {},
): HTMLElement | null {
  for (let node = element.parentElement; node; node = node.parentElement) {
    const { overflowY } = getComputedStyle(node);
    if (
      (overflowY === 'auto' || overflowY === 'scroll') &&
      (!overflowingOnly || node.scrollHeight > node.clientHeight)
    ) {
      return node;
    }
  }
  return null;
}
